import withdrawalPassword from './withdrawal-password'
export default {
  mixins: [withdrawalPassword],
  methods: {
    requestBankWithdrawal() { return this.requestWithdrawal('bank') },
    requestCryptoWithdrawal() { return this.requestWithdrawal('crypto') },
    requestWithdrawal(kind) {
      return this.ensureWithdrawalPassword(() => kind === 'crypto' ? this.doWithdrawal2() : this.doWithdrawal(), null, true)
    },
  },
}
